import React, { Component } from 'react';
import { VictoryPie, VictoryLegend } from 'victory';

import NoElements from '../../../components/states/NoElements';
import '../../../styles/ProjectDefaultTab.css';
import ColorPalette from '../RootCauseGraph/ColorPalette';

export default class RootCausePie extends Component {
  render() {
    const {
      data: { categories, values },
    } = this.props;

    let total = 0;
    let colorScale = [];

    const reasonCategories = categories.reduce((prev, cur, key) => {
      const val = values[key].reduce(
        (totalTasks, currentTask) =>
          currentTask.tasks ? totalTasks + currentTask.tasks : totalTasks,
        0,
      );

      total = total + val;

      if (val) {
        prev.push({
          reason: cur,
          total: val,
        });
        // Get color associated with this reason
        colorScale.push(ColorPalette[key % ColorPalette.length]);
      }

      return prev;
    }, []);

    const reasons = reasonCategories.map(cause => {
      return {
        name: cause.reason,
        symbol: {
          type: 'square',
        },
      };
    });

    if (!reasonCategories.length || !reasons.length) {
      return (
        <div
          style={{
            border: '1px solid rgba(0,0,0,0.125)',
          }}
        >
          <NoElements
            missingType="dashboardReport"
            missingEntity="Incomplete Tasks"
            dashboard
          />
        </div>
      );
    }
    return (
      <div
        style={{
          display: 'flex',
          padding: '0.5rem 0.75rem',
          justifyContent: 'center',
          overflowY: 'auto',
          flex: '1 1 0%',
          border: '1px solid rgba(0,0,0,0.125)',
        }}
      >
        <VictoryPie
          padding={0}
          data={reasonCategories}
          x="reason"
          innerRadius={60}
          colorScale={colorScale}
          y={datum => datum.total}
          labelRadius={85}
          style={{
            labels: { fontSize: 30, fill: 'white' },
            parent: { maxWidth: '30%', padding: 0 },
          }}
          labels={datum => {
            const value = `${((datum.total / total) * 100).toFixed(1)} %`;
            return value;
          }}
        />
        <div
          style={{
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            marginLeft: 10,
          }}
        >
          <VictoryLegend
            data={reasons}
            colorScale={colorScale}
            style={{ parent: { minWidth: '100px' }, labels: { fontFamily: 'arial', fontSize: 16 } }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Project/RootCausePie/RootCausePieContainer.js